import { useEffect, useState } from 'react';

import FormField from '@/shared/components/forms/WaveUIForm_V2/types/formField.type';

import getMetadataTransformedForm from '../utils/getMetadataTransformedForm';

const useMetadataOperations = () => {
  const [collectInventoryDetails, setCollectInventoryDetails] = useState(false);

  const [inventoryDataToSave, setInventoryDataToSave] = useState<{
    [key: string]: unknown;
    atomic_metadata: Record<string, unknown>;
  } | null>(null);

  const [isFormValid, setIsFormValid] = useState(false);

  const getInventoryDetails = (details: FormField[][], formValid?: boolean) => {
    if (details.length > 0 && formValid === undefined) {
      setInventoryDataToSave((prev) => ({
        ...getMetadataTransformedForm(details),
        atomic_metadata: { ...prev?.atomic_metadata },
      }));
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  };

  const getInventoryItemsDetails = (
    details: FormField[][],
    formValid?: boolean,
    externalFields?: Record<string, unknown>,
  ) => {
    if (details.length > 0 && formValid === undefined) {
      const { qty, ...atomicMetadata } = getMetadataTransformedForm(details);

      setInventoryDataToSave((prev) => ({
        ...prev,
        qty: parseInt(qty as string),
        atomic_metadata: atomicMetadata,
        ...externalFields,
      }));
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  };

  useEffect(() => {
    collectInventoryDetails && setCollectInventoryDetails(false);
  }, [collectInventoryDetails]);

  return {
    isFormValid,
    inventoryDataToSave,
    collectInventoryDetails,
    setCollectInventoryDetails,
    getInventoryDetails,
    getInventoryItemsDetails,
  };
};

export default useMetadataOperations;
